// App defaults
export const DEFAULT_STORAGE_KEY = 'self_test';
export const DEFAULT_LANGUAGE = 'en';
export const ENABLE_LOGS = false;
export const DUMMY_LOGGER = {
  error: () => {},
  warn: () => {},
  info: () => {},
  log: () => {},
  debug: () => {},
};

// Checks
export const BROWSER_CHECK = 'browser';
export const CAMERA_CHECK = 'camera';
export const MICROPHONE_CHECK = 'microphone';
export const SPEAKERS_CHECK = 'speakers';
export const CONNECTIVITY_CHECK = 'connectivity';

// Navigation
export const PERMISSIONS_INFO_PAGE = 'permissions';
export const INTRO_PAGE = 'intro';
export const DIAGNOSTICS_PAGE = 'checks';
export const SUMMARY_PAGE = 'summary';

// Check stage
export const PENDING = 'pending';
export const RUNNING = 'running';
export const DONE = 'done';

// Check level
export const UNKNOWN_LEVEL = -1;
export const SUCCESS_LEVEL = 0;
export const INFORMATION_LEVEL = 1
export const WARNING_LEVEL = 2;
export const ERROR_LEVEL = 3;
export const LEVEL_COLORS = { // Matches MUI Palette colors
  [UNKNOWN_LEVEL]: 'info',
  [INFORMATION_LEVEL]: 'info',
  [SUCCESS_LEVEL]: 'success',
  [WARNING_LEVEL]: 'warning',
  [ERROR_LEVEL]: 'error',
};

// DOM Elements
export const AUDIO_METER_CANVAS_ID = 'microphoneDiagnostic-canvas';
export const TONE_AUDIO_ID = 'app-audio';

// Speakers answers
export const RETRY = 'retry';
export const YES = 'yes';
export const NO = 'no';

// Layout
export const NARROW_LAYOUT = 'narrow'; // px
export const WIDE_LAYOUT = 'wide'; // px
export const PORTRAIT_LAYOUT_MAX_WIDTH = 500; // px
export const MOBILE_MAX_WIDTH = 720; // px
export const NARROW_LAYOUT_MAX_WIDTH = 1024; // px

const editableConstants = {
  ENABLE_LOGS,
};
window.PARSYSConstants = editableConstants;
